import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { switchMap, map } from 'rxjs/operators';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { NotificationService, NOTIFICATION_TYPES } from './notification.service';
import { Router } from '@angular/router';

export interface User {
  uid: string;
  email: string;
}
 
export interface Message {
  createdAt: Date;
  id: string;
  from: string;
  msg: string;
  fromName: string;
  userName:string,
  to: string;
  isRead: boolean;
  myMsg: boolean;
}
export interface MessageNotification {
  content: string,
  userId: string,
  from: string;
  createdAt: Date,
  isRead: boolean;
  hasPopped: boolean;
}

//new
export interface ChatMessage {
  msg: string;
  fromUid: string;
  toUid: string;
  fromName: string;
  createdAt: string;
  read: boolean;
  isOwner?: boolean;
}
 
@Injectable({
  providedIn: 'root'
})
export class ChatService {
  interval: any;
  getNotiSub: any;
  toast: HTMLIonToastElement;
  private subscription : Subscription = new Subscription();

  //new
  public unreadCount$ = new BehaviorSubject<number>(0);
  private isWatching = false;
  private processingNotifications = new Set<string>();
  private isToastShowing = false;

  constructor(
    private afAuth: AngularFireAuth, 
    private afs: AngularFirestore, 
    private authService : AuthService, 
    private toastCtrl: ToastController,
    private notificationService: NotificationService,
    private router : Router
    ) {}
 
 
//  watchMessages(){
//   if(this.interval){
//     clearInterval(this.interval)
//     return
//   }
//   if(this.getNotiSub){
//     this.getNotiSub.unsubscribe()
//     return
//   }
//   this.interval = setInterval(() => {
//     this.getNotiSub = this.getNotifications(this.authService.employeeId).subscribe(res => {
//       const notiNotPopped = res.filter(x => !x.hasPopped)
//       console.log("🚀 ~ notiNotPoppedx", notiNotPopped)
//       if(notiNotPopped.length > 0){
//         notiNotPopped.forEach(x => {
//           this.clearNotificationPop(x).then(res => {
//             console.log("🚀 ~ res", res)
//             this.presentToast(x)
//           });
//         })
//       }
//     });
//   }, 3000)
//   return true
//  }

  //Updated vwatch message
  watchMessages() {
    // Prevent multiple watchers
    if (this.isWatching) {
      console.log('Already watching messages');
      return true;
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.getNotiSub) {
      this.getNotiSub.unsubscribe();
    }

    this.isWatching = true;

    this.interval = setInterval(() => {
      if (!this.authService.employeeId) {
        return;
      }
      // unsub from previous subscription
      if (this.getNotiSub) {
        this.getNotiSub.unsubscribe();
      }

      this.getNotiSub = this.getNotifications(this.authService.employeeId).subscribe(res => {
        // Update unread count
        this.unreadCount$.next(res.length);

        const notiNotPopped = res.filter(x => !x.hasPopped);
        console.log("🚀 ~ notiNotPopped", notiNotPopped);

        if (notiNotPopped.length > 0) {
          // notiNotPopped.forEach(x => {
          //   this.clearNotificationPop(x).then(() => {
          //     // ✅ Only show toast if NOT on chat page with that user
          //     const currentUrl = this.router.url;
          //     const isOnChatWithUser = currentUrl.includes('/chat') && currentUrl.includes(x.from);
              
          //     if (!isOnChatWithUser) {
          //       this.presentToast(x);
          //     }
          //   });
          // });
          this.processNotification(notiNotPopped[0]);
        }
      });
    }, 3000);

    return true;
  }

  private async processNotification(noti: MessageNotification) {
    // Create a unique key for this notification
    const notiKey = `${noti.from}_${noti.userId}_${noti.createdAt}`;
    
    // Skip if already processing this notification
    if (this.processingNotifications.has(notiKey)) {
      console.log('Notification already being processed:', notiKey);
      return;
    }
    
    // Skip if a toast is currently showing
    if (this.isToastShowing) {
      console.log('Toast already showing, skipping');
      return;
    }

    // Mark as processing
    this.processingNotifications.add(notiKey);

    try {
      // Mark as popped in Firebase FIRST (before showing toast)
      await this.clearNotificationPop(noti);
      
      // Check if user is on chat page with this person
      const currentUrl = this.router.url;
      const isOnChatWithUser = currentUrl.includes('/chat') && currentUrl.includes(noti.from);
      
      if (!isOnChatWithUser) {
        await this.presentToast(noti);
      }
    } catch (error) {
      console.error('Error processing notification:', error);
    } finally {
      // Remove from processing set after a delay
      setTimeout(() => {
        this.processingNotifications.delete(notiKey);
      }, 5000);
    }
  }


  // ✅ NEW: Stop watching messages (call on logout)
  stopWatchingMessages() {
    this.isWatching = false;
    
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    if (this.getNotiSub) {
      this.getNotiSub.unsubscribe();
      this.getNotiSub = null;
    }
    
    this.unreadCount$.next(0);
  }
 
  // TODO Chat functionality
  // addChatMessage(msg,FromUid,ToUid,name) {
  //   this.afs.collection('notification').add({
  //     content: `${name} has sent you a message`,
  //     userId: ToUid,
  //     from: FromUid,
  //     createdAt: new Date(),
  //     isRead:false,
  //     hasPopped:false,
  //   });

  //   return this.afs.collection('messages').add({
  //     msg: msg,
  //     from: FromUid,
  //     to:ToUid,
  //     userName:name,
  //     isRead:false,
  //     createdAt: new Date(),
  //   });
  // }

  //updated add chat maessage
  addChatMessage(msg: string, FromUid: string, ToUid: string, name: string) {
    // Add notification to Firebase
    this.afs.collection('notification').add({
      content: `${name} has sent you a message`,
      userId: ToUid,
      from: FromUid,
      createdAt: new Date(),
      isRead: false,
      hasPopped: false,
    });

    // ✅ Also add to your backend notifications (for notification page)
    this.notificationService.addnotifications(
      `${name}: ${msg.length > 50 ? msg.substring(0, 50) + '...' : msg}`,
      parseInt(ToUid),
      NOTIFICATION_TYPES.CHAT,
      parseInt(FromUid), // Store sender ID for navigation
      '', // profile image
      this.authService.clientId
    ).subscribe({
      next: () => console.log('Backend notification added'),
      error: (err) => console.error('Error adding backend notification:', err)
    });

    // Add message to Firebase
    return this.afs.collection('messages').add({
      msg: msg,
      from: FromUid,
      to: ToUid,
      userName: name,
      isRead: false,
      createdAt: new Date(),
    });
  }
   
  getChatMessages(Fromuid,toUid) {
    let users = [];
    return this.getUsers().pipe(
      switchMap(res => {
        users = res;
        return this.afs.collection('messages', ref => ref.orderBy('createdAt')).valueChanges() as Observable<Message[]>;
      }),
      map(messages => {
        messages = messages.filter(x => ((x.from === Fromuid && x.to === toUid) ||  (x.from === toUid && x.to === Fromuid)));
       for (let m of messages) {       
         
          m.fromName = m.userName;
          m.myMsg = Fromuid === m.from;
        }        
        return messages
      })
    )
  }

  getNotifications(toUid) {
    let users = [];
    return this.getUsers().pipe(
      switchMap(res => {
        users = res;
        return this.afs.collection('notification', ref => ref.orderBy('createdAt', 'desc')).valueChanges() as Observable<MessageNotification[]>;
      }),
      map(notis => {
        notis = notis.filter(x => !x.isRead && x.userId === toUid && x.from);      
        return notis
      })
    )
  }

  clearNotification(FromUid,ToUid){
    return this.afs.collection<MessageNotification>('notification', ref => ref.where('from', '==', FromUid).where('userId', '==', ToUid)).get().subscribe(querySnapshot => {
      querySnapshot.forEach(doc => {
        doc.ref.update({'isRead': true})
      })
    });
  }
  // clearNotificationPop(noti: MessageNotification){
  //   return this.afs.collection<MessageNotification>('notification', ref => ref.where('from', '==', noti.from).where('userId', '==', noti.userId).where('createdAt', '==', noti.createdAt)).get().toPromise().then(querySnapshot => {
  //     querySnapshot.forEach(doc => {
  //       doc.ref.update({'hasPopped': true})
  //     })
  //   });
  // }

  clearNotificationPop(noti: MessageNotification): Promise<void> {
    return this.afs.collection<MessageNotification>('notification', ref => 
      ref.where('from', '==', noti.from)
         .where('userId', '==', noti.userId)
         .where('createdAt', '==', noti.createdAt)
    ).get().toPromise().then(querySnapshot => {
      const batch = this.afs.firestore.batch();
      querySnapshot.forEach(doc => {
        batch.update(doc.ref, { 'hasPopped': true });
      });
      return batch.commit();
    }).then(() => {
      console.log('Notification marked as popped');
    });
  }
   
  private getUsers() {
    return this.afs.collection('messages').valueChanges() as Observable<User[]>;
  }
   
  // private getUserForMsg(msgFromId, users: User[]): string {    
  //   for (let usr of users) {
  //     if (usr.uid == msgFromId) {
  //       return usr.email;
  //     }
  //   }
  //   return 'Deleted';
  // }

  // ✅ NEW: Get unread count for a specific user
  getUnreadCount(userId: string): Observable<number> {
    return this.getNotifications(userId).pipe(
      map(notifications => notifications.length)
    );
  }

  // ✅ NEW: Mark all messages from a user as read
  markMessagesAsRead(fromUid: string, toUid: string) {
    // Mark Firebase notifications as read
    this.clearNotification(fromUid, toUid);

    // Mark individual messages as read
    return this.afs.collection<Message>('messages', ref => 
      ref.where('from', '==', fromUid).where('to', '==', toUid).where('isRead', '==', false)
    ).get().subscribe(querySnapshot => {
      querySnapshot.forEach(doc => {
        doc.ref.update({ 'isRead': true });
      });
    });
  }

  // async presentToast(noti: MessageNotification, duration: number = 3000, position: any = 'top') {
  //   this.toast = await this.toastCtrl.create({ message: noti.content, duration, position });
  //   this.toast.present();
  // }

  //updated toast
  // async presentToast(noti: MessageNotification, duration: number = 4000, position: any = 'top') {
  //   // Dismiss any existing toast first
  //   if (this.toast) {
  //     await this.toast.dismiss();
  //   }

  //   this.toast = await this.toastCtrl.create({ 
  //     message: noti.content, 
  //     duration, 
  //     position,
  //     color: 'primary',
  //     buttons: [
  //       {
  //         text: 'View',
  //         handler: () => {
  //           // Navigate to chat with the sender
  //           this.router.navigate(['/chat'], {
  //             queryParams: { userid: noti.from }
  //           });
  //         }
  //       },
  //       {
  //         text: 'Dismiss',
  //         role: 'cancel'
  //       }
  //     ]
  //   });
    
  //   await this.toast.present();
  // }
  async presentToast(noti: MessageNotification, duration: number = 4000, position: any = 'top') {
    // Don't show if already showing
    if (this.isToastShowing) {
      console.log('Toast already showing');
      return;
    }

    // Dismiss any existing toast first
    if (this.toast) {
      try {
        await this.toast.dismiss();
      } catch (e) {
        // Toast might already be dismissed
      }
    }

    this.isToastShowing = true;

    this.toast = await this.toastCtrl.create({ 
      message: noti.content, 
      duration, 
      position,
      color: 'primary',
      buttons: [
        {
          text: 'View',
          handler: () => {
            this.router.navigate(['/chat'], {
              queryParams: { userid: noti.from }
            });
          }
        },
        {
          text: 'Dismiss',
          role: 'cancel'
        }
      ]
    });
    
    // Reset flag when toast is dismissed
    this.toast.onDidDismiss().then(() => {
      this.isToastShowing = false;
    });

    await this.toast.present();
  }

  // ✅ NEW: Clean up subscriptions
  ngOnDestroy() {
    this.stopWatchingMessages();
    this.subscription.unsubscribe();
  }
  
}